"use strict";
/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/hossiiii0117/React/TokenLive/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MosaicHttp = void 0;

var operators_1 = require("rxjs/operators");

var symbol_openapi_typescript_fetch_client_1 = require("symbol-openapi-typescript-fetch-client");

var DtoMapping_1 = require("../core/utils/DtoMapping");

var MosaicFlags_1 = require("../model/mosaic/MosaicFlags");

var MosaicId_1 = require("../model/mosaic/MosaicId");

var MosaicInfo_1 = require("../model/mosaic/MosaicInfo");

var UInt64_1 = require("../model/UInt64");

var Http_1 = require("./Http");

var paginationStreamer_1 = require("./paginationStreamer");
/**
 * Mosaic http repository.
 *
 * @since 1.0
 */


var MosaicHttp = /*#__PURE__*/function (_Http_1$Http) {
  _inherits(MosaicHttp, _Http_1$Http);

  var _super = _createSuper(MosaicHttp);

  /**
   * Constructor
   * @param url Base catapult-rest url
   * @param networkType the network type.
   * @param fetchApi fetch function to be used when performing rest requests.
   */
  function MosaicHttp(url, networkType, fetchApi) {
    var _this;

    _classCallCheck(this, MosaicHttp);

    _this = _super.call(this, url, fetchApi);
    _this.mosaicRoutesApi = new symbol_openapi_typescript_fetch_client_1.MosaicRoutesApi(_this.config());
    _this.networkTypeObservable = _this.createNetworkTypeObservable(networkType);
    return _this;
  }
  /**
   * Gets the MosaicInfo for a given mosaicId
   * @param mosaicId - Mosaic id
   * @returns Observable<MosaicInfo>
   */


  _createClass(MosaicHttp, [{
    key: "getMosaic",
    value: function getMosaic(mosaicId) {
      return this.call(this.mosaicRoutesApi.getMosaic(mosaicId.toHex()), function (body) {
        return MosaicHttp.toMosaicInfo(body);
      });
    }
    /**
     * Gets MosaicInfo for different mosaicIds.
     * @param mosaicIds - Array of mosaic ids
     * @returns Observable<MosaicInfo[]>
     */

  }, {
    key: "getMosaics",
    value: function getMosaics(mosaicIds) {
      return this.call(this.mosaicRoutesApi.getMosaics({
        mosaicIds: mosaicIds.map(function (id) {
          return id.toHex();
        })
      }), function (body) {
        return body.map(function (b) {
          return MosaicHttp.toMosaicInfo(b);
        });
      });
    }
    /**
     * Gets a MosaicInfo merkle for a given mosaicId
     * @param mosaicId - Mosaic id
     * @returns Observable<MerkleStateInfo>
     */

  }, {
    key: "getMosaicMerkle",
    value: function getMosaicMerkle(mosaicId) {
      return this.call(this.mosaicRoutesApi.getMosaicMerkle(mosaicId.toHex()), DtoMapping_1.DtoMapping.toMerkleStateInfo);
    }
    /**
     * Gets an array of mosaics.
     * @summary Get mosaics created for given address
     * @param criteria Mosaic search criteria
     * @returns {Page<MosaicInfo>}
     */

  }, {
    key: "search",
    value: function search(criteria) {
      var _this2 = this;

      return this.networkTypeObservable.pipe((0, operators_1.mergeMap)(function (networkType) {
        var _a;

        return _this2.call(_this2.mosaicRoutesApi.searchMosaics((_a = criteria.ownerAddress) === null || _a === void 0 ? void 0 : _a.plain(), criteria.pageSize, criteria.pageNumber, criteria.offset, DtoMapping_1.DtoMapping.mapEnum(criteria.order)), function (body) {
          return _get(_getPrototypeOf(MosaicHttp.prototype), "toPage", _this2).call(_this2, body.pagination, body.data, MosaicHttp.toMosaicInfo, networkType);
        });
      }));
    }
  }, {
    key: "streamer",
    value: function streamer() {
      return new paginationStreamer_1.MosaicPaginationStreamer(this);
    }
    /**
     * Maps MosaicInfoDTO to MosaicInfo
     *
     * @param mosaicInfo the dto object.
     * @returns the model object
     */

  }], [{
    key: "toMosaicInfo",
    value: function toMosaicInfo(mosaicInfo) {
      return new MosaicInfo_1.MosaicInfo(mosaicInfo.mosaic.version || 1, mosaicInfo.id, new MosaicId_1.MosaicId(mosaicInfo.mosaic.id), UInt64_1.UInt64.fromNumericString(mosaicInfo.mosaic.supply), UInt64_1.UInt64.fromNumericString(mosaicInfo.mosaic.startHeight), DtoMapping_1.DtoMapping.toAddress(mosaicInfo.mosaic.ownerAddress), mosaicInfo.mosaic.revision, new MosaicFlags_1.MosaicFlags(mosaicInfo.mosaic.flags), mosaicInfo.mosaic.divisibility, UInt64_1.UInt64.fromNumericString(mosaicInfo.mosaic.duration));
    }
  }]);

  return MosaicHttp;
}(Http_1.Http);

exports.MosaicHttp = MosaicHttp;